var version = '5.19.3';
export { version as default };
//# sourceMappingURL=version.js.map
